module.exports = __webpack_public_path__ + "img/ohrimenko.ff31f638.jpg";